import React from 'react';

import { formatMoney, toMoney } from '@betterment/core';
import { Table } from '@betterment/samba-react';

import { BillingPlanDisplayFragment } from '../../../../graphql/fragments/billing_plan_display.generated';
import { BillingRateRange } from '../../../../graphql/schema';

const TieredRateTable: React.FC<{ plan: BillingPlanDisplayFragment }> = ({ plan }) => {
  const getTiers = (): Array<BillingRateRange> => {
    if ('tiers' in plan.billingRate) {
      return plan.billingRate.tiers;
    }
    return [];
  };
  const tiers: Array<BillingRateRange> = getTiers();

  const tierRange = (tier: BillingRateRange, index): string => {
    const tierStart = index === 0 ? toMoney(0) : tiers[index - 1].tierEnd;
    const tierEndText = tier.tierEnd ? `- ${formatMoney(tier.tierEnd, 'defaultOptional')}` : 'and up';

    // @ts-expect-error TS2345 violates strict null checks
    return `${formatMoney(tierStart, 'defaultOptional')} ${tierEndText}`;
  };

  const tierRate = (tier: BillingRateRange): string => {
    if (tier.firmFee.__typename === 'BillingRateFixed') {
      return `${formatMoney(tier.firmFee.feeCents, 'defaultOptional')}`;
    }
    return `${tier.firmFee.feeBps} bps`;
  };

  return (
    <Table>
      <Table.Header>
        <Table.Row>
          <Table.ColumnHeaderCell css={{ pl: '0', pb: 'space.100' }}>Client AUM range</Table.ColumnHeaderCell>
          <Table.ColumnHeaderCell css={{ pb: 'space.100' }}>Advisory fee</Table.ColumnHeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {tiers.map((tier, index) => (
          <Table.Row key={`rateTier-${plan.id + index.toString()}`}>
            <Table.Cell css={{ pl: '0' }}>{tierRange(tier, index)}</Table.Cell>
            <Table.Cell>{tierRate(tier)}</Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
};

export default TieredRateTable;
